import React from 'react';
import PropTypes from 'prop-types';

import CertsListDiscontinue from './CertsListDiscontinue';
import CertsListEmailHistory from './CertsListEmailHistory';
import CertsListExport from './CertsListExport';
import CertsListReassign from './CertsListReassign';
import {
  ACT_DISCONTINUE,
  ACT_EMAIL_HISTORY,
  ACT_EXPORT,
  ACT_REASSIGN,
} from './constant';

function CertsListActionComponent({
  action,
  isOpen,
  setIsOpen,
  certKey,
  tileCampaignKey,
  certificationName,
  campaignType,
}) {
  if (!isOpen) return null;

  const handleSetIsOpenWithAction = (newIsOpen) => setIsOpen(action, newIsOpen);

  switch (action) {
    case ACT_EXPORT:
      return (
        <CertsListExport
          isOpen={isOpen}
          setIsOpen={handleSetIsOpenWithAction}
          certKey={certKey}
          tileCampaignKey={tileCampaignKey}
          campaignType={campaignType}
        />
      );
    case ACT_REASSIGN:
      return (
        <CertsListReassign
          isOpen={isOpen}
          setIsOpen={handleSetIsOpenWithAction}
          certKey={certKey}
        />
      );
    case ACT_DISCONTINUE:
      return (
        <CertsListDiscontinue
          isOpen={isOpen}
          setIsOpen={handleSetIsOpenWithAction}
          certKey={certKey}
          certificationName={certificationName}
        />
      );
    case ACT_EMAIL_HISTORY:
      return (
        <CertsListEmailHistory
          isOpen={isOpen}
          setIsOpen={handleSetIsOpenWithAction}
          certKey={certKey}
        />
      );
    default:
      return null;
  }
}

CertsListActionComponent.propTypes = {
  action: PropTypes.oneOf([
    ACT_EXPORT,
    ACT_REASSIGN,
    ACT_DISCONTINUE,
    ACT_EMAIL_HISTORY,
  ]),
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  certKey: PropTypes.number,
  tileCampaignKey: PropTypes.number.isRequired,
  certificationName: PropTypes.string.isRequired,
  campaignType: PropTypes.string.isRequired,
};

CertsListActionComponent.defaultProps = {
  action: null,
  certKey: null,
};

export default CertsListActionComponent;
